import { useQuery } from "@tanstack/react-query";
import {
  alternativeTransportResponseSchema,
  AlternativeTransportVehicle,
} from "shared/types/alternativeTransport";
import * as z from "zod";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";

export const isShuttleVehicle = (
  vehicle: AlternativeTransportVehicle,
): boolean =>
  vehicle.serviceType === "OPERATIONAL" && vehicle.isPartOfShuttlePlan;

export const useAlternativeTransportData = (vehicleUuid?: string) =>
  useQuery({
    queryKey: ["altTransDetails", vehicleUuid],
    enabled: !!vehicleUuid,
    refetchInterval: 30000,
    queryFn: async ({ signal }) =>
      axiosClient
        .get<
          z.infer<typeof alternativeTransportResponseSchema>
        >(`${getBackendUrl()}/alternativeTransports/${vehicleUuid}`, { signal })
        .then((res) => alternativeTransportResponseSchema.parse(res.data)),
  });
